<div class="button-wrapper" style="width: 120px; margin-left: 12px; margin-right: 12px">
    <button
        [disabled]="disabled"
        *ngIf="showIcon"
        [color]="color"
        [@slideInLeft]
        mat-icon-button
        (click)="clickedIcon($event)"
    >
        <mat-icon style="transform: scale(0.8)">delete</mat-icon>
    </button>
    <button
        [disabled]="disabled"
        *ngIf="!showIcon"
        [@slideInRight]
        mat-flat-button
        color="warn"
        (click)="clickedButton($event)"
        >Jetzt l&ouml;schen
    </button>
</div>
